export const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';
export const AUTH_EVENT_KEY = 'auth-storage';
